// extracted by mini-css-extract-plugin
export default {"container":"RecordingLabel_container__c2W9W","recordingDot":"RecordingLabel_recordingDot__xDEcG","blink":"RecordingLabel_blink__E0qmA"};